module.exports = __webpack_public_path__ + "static/img/icon4-9.86f03016.png";